import moment from 'moment';
import PropTypes from 'prop-types';
import { Paper, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import store from '../../store';
import { useTranslation } from '../../common/LocalizationProvider';
import { calculNbG } from '../../common/utils/unitConverter';

export const getMomentAsNumber = (time) => Number(moment(time).format('x'));

// ----------------------------------------------------------------------
CustomReferenceDot.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired
};
export function CustomReferenceDot(props) {
  return (
    <circle cx={props.cx} r="5" cy={props.cy} fill="#bb0b0b">
      <animate attributeName="r" from="5" to="10" dur="1.5s" begin="0s" repeatCount="indefinite" />
    </circle>
  );
}

CustomReferenceDotWarning.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired
};
export function CustomReferenceDotWarning(props) {
  return (
    <circle cx={props.cx} r="5" cy={props.cy} fill="#FF9966">
      <animate attributeName="r" from="5" to="10" dur="1.5s" begin="0s" repeatCount="indefinite" />
    </circle>
  );
}

CustomReferenceDotPhase.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired
};
export function CustomReferenceDotPhase(props, color) {
  return (
    <circle cx={props.cx} r="5" cy={props.cy} fill={color}>
      <animate attributeName="r" from="5" to="8" dur="1.5s" begin="0s" repeatCount="indefinite" />
    </circle>
  );
}

CustomReferenceCurrentPosition.propTypes = {
  cx: PropTypes.number.isRequired,
  cy: PropTypes.number.isRequired
};
export function CustomReferenceCurrentPosition(props) {
  return <circle cx={props.cx} r="6" cy={props.cy} fill="#e50e58" />;
}
// ----------------------------------------------------------------------

export function modelTooltip(
  fixTime,
  stringTime,
  altitude,
  stringAltitude,
  elevation,
  stringElevation,
  speed,
  stringSpeed,
  nbG,
  stringNbG,
  isDarkMode
) {
  const session = store.getState().session.items;
  return (
    <Paper>
      <Typography
        style={{
          marginLeft: 2,
          marginRight: 2,
          color: isDarkMode === true ? '#fff' : '#000'
        }}
        variant="subtitle2"
      >
        {`${stringTime}: ${moment(fixTime).format('HH:mm:ss')}`}
      </Typography>
      <Typography style={{ marginLeft: 2, marginRight: 2, color: '#22398d' }} variant="subtitle2">
        {`${stringAltitude}: ${
          session.uniteAltitude === 'm' ? altitude.toFixed(0) : (altitude * 3.262).toFixed(0)
        } ${session.uniteAltitude}`}
      </Typography>
      {elevation !== undefined && (
        <Typography style={{ marginLeft: 2, marginRight: 2, color: '#c8ad7f' }} variant="subtitle2">
          {`${stringElevation}: ${
            // eslint-disable-next-line no-nested-ternary
            session.uniteAltitude === 'm'
              ? altitude - elevation > 0
                ? Math.abs(altitude - elevation).toFixed(0)
                : 0
              : altitude - elevation > 0
              ? (Math.abs(altitude - elevation) * 3.262).toFixed(0)
              : 0
          } ${session.uniteAltitude}`}
        </Typography>
      )}
      <Typography style={{ marginLeft: 2, marginRight: 2, color: '#e50e58' }} variant="subtitle2">
        {`${stringSpeed}: ${
          session.uniteVitesse === 'km/h' ? (speed * 1.852).toFixed(0) : speed.toFixed(0)
        } ${session.uniteVitesse}`}
      </Typography>

      <Typography style={{ marginLeft: 2, marginRight: 2, color: '#826AF9' }} variant="subtitle2">
        {`${stringNbG}: ${nbG}`}
      </Typography>
    </Paper>
  );
}

CustomTooltip.propTypes = {
  active: PropTypes.bool,
  payload: PropTypes.array
};

export function CustomTooltip({ active, payload, currentPosition }) {
  const theme = useTheme();
  const isDarkMode = theme.palette.mode === 'dark';
  const t = useTranslation();
  if (active && payload && payload.length) {
    return modelTooltip(
      payload[0].payload.fixTime,
      t('FR_Graph_Time'),
      payload[0].payload.altitude,
      t('FR_Graph_Altitude'),
      payload[0].payload.attributes.elevation,
      t('LM_Elevation'),
      payload[0].payload.speed,
      t('LM_Speed'),
      calculNbG(payload[0].payload) || 0,
      'G',
      isDarkMode
    );
  }
  return modelTooltip(
    currentPosition ? currentPosition.fixTime : '',
    t('FR_Graph_Time'),
    currentPosition ? currentPosition.altitude : 0.0,
    t('FR_Graph_Altitude'),
    currentPosition ? currentPosition.attributes.elevation : 0.0,
    t('LM_Elevation'),
    currentPosition ? currentPosition.speed : 0.0,
    t('LM_Speed'),
    (currentPosition && calculNbG(currentPosition)) || 0,
    'G',
    isDarkMode
  );
}

// ----------------------------------------------------------------------
